export const makeQueryParams = (params, ParamsDict) => {
  let url = ''
  for (const property in params) {
    if (Object.hasOwnProperty.call(params, property)) {
      const value = params[property]

      if (ParamsDict[property] && !!value) {
        url =
          url.length > 0
            ? url.concat(`&${ParamsDict[property]}${value}`)
            : url.concat(`${ParamsDict[property]}${value}`)
      }
    }
  }
  return url
}



// WEBPACK FOOTER //
// ./src/lib/apiHooks/shared.js